export default __webpack_public_path__ + "static/media/UdunkuluLady.ef53d7f1.svg";